interface FractionalTime {
  hours: number;
  minutes: number;
  seconds: number;
  days: number;
}

export const secondsToFractional = (seconds: number): FractionalTime => {
  const days = Math.floor(seconds / (3600 * 24));
  seconds %= 3600 * 24;
  const hours = Math.floor(seconds / 3600);
  seconds %= 3600;
  const minutes = Math.floor(seconds / 60);
  seconds = seconds % 60;

  return {
    hours,
    minutes,
    seconds,
    days,
  };
};

export const fractionalToSeconds = ({ hours, minutes, seconds, days }: FractionalTime) =>
  days * 3600 * 24 + hours * 3600 + minutes * 60 + seconds;
